<template>
  <RouterView />

  <Teleport to="body">
    <LoadingComponent />
    <ToastComponent />
  </Teleport>
</template>

<script setup lang="ts">
import ToastComponent from '@/components/ToastComponent.vue'
import LoadingComponent from '@/components/LoadingComponent.vue'
import { useCacheStore } from '@/stores/cache.ts'
import { onMounted } from 'vue'
import { useLoadingStore } from '@/stores/loading.ts'

const cacheStore = useCacheStore()
const loadingStore = useLoadingStore()

onMounted(async () => {
  loadingStore.start()
  try {
    await cacheStore.getCache()
  } finally {
    loadingStore.stop()
  }
})
</script>
